import { OrganizationPropertyOutput } from 'organization/model/organization-property.output';
import { OrganizationProperty } from 'organization/organization-property';

export abstract class OrganizationPropertiesConverterPort {
	public abstract organizationPropertyAsEntity(
		output: OrganizationPropertyOutput
	): OrganizationProperty;

	public abstract organizationPropertiesAsEntities(
		outputs: OrganizationPropertyOutput[]
	): OrganizationProperty[];
}
